import { openkit } from "../../library/database";
import moment from "moment";

export const getEventCategories = async (info) => {
  const today = moment();
  const oneMonthAgo = today.subtract(1, "month");
  const query = {
    type: "event",
    eve_date: { _gte: oneMonthAgo },
    _select: ["eve_category"],
  };
  if (info.commonFilter.villages.length)
    query.eve_location = { _in: info.commonFilter.villages };
  if (info.commonFilter.name) query.name = { _like: info.commonFilter.name };
  if (info.event.date) query.eve_date = info.event.date;
  const eventCategories = await openkit.data.find("c_stores", query);
  const eventCategoriesArray = eventCategories.map((d) => d.eve_category);
  const eventUniqueCategoriesArray = [...new Set(eventCategoriesArray)];
  return eventUniqueCategoriesArray;
};

export const getEventDates = async (info) => {
  const today = moment();
  const oneMonthAgo = today.subtract(1, "month");
  const query = {
    type: "event",
    eve_date: { _gte: oneMonthAgo },
    _select: ["eve_date"],
  };
  if (info.commonFilter.villages.length)
    query.eve_location = { _in: info.commonFilter.villages };
  if (info.commonFilter.name) query.name = { _like: info.commonFilter.name };
  if (info.event.category) query.eve_category = info.event.category;
  const eventDates = await openkit.data.find("c_stores", query);
  const eventDatesArray = eventDates.map((d) => d.eve_date);
  return eventDatesArray;
};

export const getEvents = async (info) => {
  let query = {};
  query.type = "event";
  if (info.event.date) query.eve_date = info.event.date;
  else query.eve_date = "_is_not_null";
  if (info.event.category) query.eve_category = info.event.category;
  if (info.commonFilter.villages.length)
    query.eve_location = { _in: info.commonFilter.villages };
  if (info.commonFilter.name) query.name = { _like: info.commonFilter.name };

  let events = await openkit.data.find("c_stores", query);

  //

  // all events are available for purchasing
  events = events.map((ev) => ({ ...ev, status: "available" }));
  return events;
};
